export default __webpack_public_path__ + "static/media/01e_fold-5.691c2258.mp4";